import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAppStore } from './store/appStore';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Footer from './components/Footer';
import Landing from './pages/Landing';
import MessageViewer from './pages/MessageViewer';
import SearchResults from './pages/SearchResults';
import Favorites from './pages/Favorites';
import RecentlyViewed from './pages/RecentlyViewed';
import DataTypes from './pages/DataTypes';
import DataItems from './pages/DataItems';
import GemCapabilities from './pages/GemCapabilities';

function App() {
  const { sidebarCollapsed, sidebarWidth } = useAppStore();

  return (
    <BrowserRouter>
      <div className="min-h-screen flex flex-col">
        <Header />

        <div className="flex flex-1 overflow-hidden">
          <Sidebar />

          <div
            style={{
              marginLeft: sidebarCollapsed ? '0' : `${sidebarWidth}px`
            }}
            className="flex-1 flex flex-col overflow-auto transition-all duration-300"
          >
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/message/:messageId" element={<MessageViewer />} />
                <Route path="/search" element={<SearchResults />} />
                <Route path="/favorites" element={<Favorites />} />
                <Route path="/recent" element={<RecentlyViewed />} />
                <Route path="/data-types" element={<DataTypes />} />
                <Route path="/data-items" element={<DataItems />} />
                <Route path="/data-items/:name" element={<DataItems />} />
                <Route path="/gem" element={<GemCapabilities />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </div>
      </div>
    </BrowserRouter>
  );
}

export default App;
